/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import decompressObject from 'components/common/Utils/decompressObject';
import { AlertData, AlertReplayResponse, AlertRequest } from 'models/viewModels';
import { MotorsportsError } from 'services/motorsportsError/MotorsportsError';

class AlertApi {
  async getAlertBackfill(params: AlertRequest): Promise<AlertData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/alert', params)
      .then((response) => response.data as AlertData[])
      .catch((e) => {
        console.log(e);
        return [];
      });
  }

  async getAlertReplay(params: AlertRequest): Promise<AlertReplayResponse> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/replay/alert', params)
      .then(
        (
          res // Ternary is to address issue when API throws an error, and res.data is an exception instead of an encoded string
        ) => (res.data.statusCode ? res.data : decompressObject<AlertData[]>(res.data))
      )
      .catch((error) => {
        console.log(error);
        new MotorsportsError(error.message, error.response?.status, error.response?.data);
      });
  }
}

export const alertApi = new AlertApi();
